import { CmsSellerFilters, CustomCmsSeller, CustomCmsSellerType } from '../../domain/seller'
import { getIsKoreaLocale } from '../../presentation/utils/locale.utils'
import { SellersDocument } from '../../queries/Sellers.gql'
import useCurrentLocale from './useCurrentLocale'
import { useQuery } from './useQuery'

const useCmsSellers = (filters: CmsSellerFilters = {}): CustomCmsSeller[] => {
  const { data } = useQuery(SellersDocument, { variables: { filters } })
  const customCmsSellers: CustomCmsSeller[] = []

  const locale = useCurrentLocale();
  const isUserInKorea = getIsKoreaLocale(locale)
  // const KOREA_BOUNDS = {
  //   north: 45.1164073,
  //   south: 31.4430027,
  //   east: 137.9097847,
  //   west: 111.0811714
  // }

  const KOREA_BOUNDS = {
    north: 38.6347,
    south: 33.0,
    east: 131.8723,
    west: 124.6093
  }

  data?.sellers?.forEach((seller) => {

    // apply coordinate filter for Korea
    if (isUserInKorea) {

      if(!seller?.longitude || !seller?.latitude){
        return;
      }

      const latitude = parseFloat(seller?.latitude)
      const longitude = parseFloat(seller?.longitude)

      // Check if the seller's location is within the South Korea bounds
      if (
        latitude < KOREA_BOUNDS.south ||
        latitude > KOREA_BOUNDS.north ||
        longitude < KOREA_BOUNDS.west ||
        longitude > KOREA_BOUNDS.east
      ) {
        return // Skip sellers outside Korea bounds
      }
    }

    const customSeller: CustomCmsSeller = {
      id: seller?.id || 0,
      name: seller?.name || '',
      description: seller?.description || '',
      type: seller?.type as CustomCmsSellerType,
      longitude: seller?.longitude || '',
      latitude: seller?.latitude || '',
      isActive: seller?.is_active || false,
      phone: seller?.phone || '',
      address: seller?.address || '',
      street: seller?.street?.[0] || '',
      city: seller?.city || '',
      country: seller?.name_country || '',
      url: seller?.url || '',
      postCode: seller?.postCode || '',
      openingHours: seller?.schedule?.openingHours || '',
      categories: [],
      isMessika: seller?.is_messika ?? false,
      image: seller?.image || '',
    }

    seller?.categories?.forEach((category) => {
      if (category) {
        customSeller.categories.push(category)
      }
    })

    customCmsSellers.push(customSeller)
  })

  return customCmsSellers
}

export default useCmsSellers
